export default () => {
    return {
        activeBrands: [],
        activeFilters: [],
        attributeFilters: [],
        categoryPath: [],
        currentCategoryId: 0,
        endpoint: null,
        error: null,
        filterCategories: {},
        filterPrice: {},
        filters: {},
        hasResult: false,
        headerText: null,
        internalSearch: {},
        introText: null,
        isFetchingGeolocation: false,
        isFilterOpen: false,
        isSavedSearchEmailEnabled: false,
        isShopOwnedByCurrentMember: false,
        items: [],
        itemsOnDisplay: [],
        mainText: null,
        pagination: null,
        queryParams: {},
        totalItems: 0,
        reduxContainer: {},
        searchLanguages: []
    };
};
